import { useSelector } from 'react-redux';

import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import type { MassLanding } from '@/domains/productDiscovery/ProductPage/interfaces/Detail.common.model';

export const massLandingsSelector = (
  state: SpartacuxProductDiscoveryDomainState<'b2c'>,
): MassLanding[] =>
  state.productDiscovery?.productPage?.detail?.data?.massLandings || [];

export const useMassLandings = (): MassLanding[] =>
  useSelector<SpartacuxProductDiscoveryDomainState, MassLanding[]>(
    massLandingsSelector,
  );
